/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusSystemNumberDto } from './NovitusSystemNumberDto';
import {
    NovitusSystemNumberDtoFromJSON,
    NovitusSystemNumberDtoFromJSONTyped,
    NovitusSystemNumberDtoToJSON,
} from './NovitusSystemNumberDto';
import type { NovitusQrcodeDto } from './NovitusQrcodeDto';
import {
    NovitusQrcodeDtoFromJSON,
    NovitusQrcodeDtoFromJSONTyped,
    NovitusQrcodeDtoToJSON,
} from './NovitusQrcodeDto';

/**
 * 
 * @export
 * @interface NovitusSystemInfoDto
 */
export interface NovitusSystemInfoDto {
    /**
     * Nazwa kasjera
     * @type {string}
     * @memberof NovitusSystemInfoDto
     */
    cashier_name?: string;
    /**
     * Numer kasy fiskalnej
     * @type {string}
     * @memberof NovitusSystemInfoDto
     */
    cash_number?: string;
    /**
     * Numer systemowy
     * @type {NovitusSystemNumberDto}
     * @memberof NovitusSystemInfoDto
     */
    system_number?: NovitusSystemNumberDto;
    /**
     * Kod QR
     * @type {NovitusQrcodeDto}
     * @memberof NovitusSystemInfoDto
     */
    qr_code?: NovitusQrcodeDto;
}

/**
 * Check if a given object implements the NovitusSystemInfoDto interface.
 */
export function instanceOfNovitusSystemInfoDto(value: object): value is NovitusSystemInfoDto {
    return true;
}

export function NovitusSystemInfoDtoFromJSON(json: any): NovitusSystemInfoDto {
    return NovitusSystemInfoDtoFromJSONTyped(json, false);
}

export function NovitusSystemInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusSystemInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cashier_name': json['cashier_name'] == null ? undefined : json['cashier_name'],
        'cash_number': json['cash_number'] == null ? undefined : json['cash_number'],
        'system_number': json['system_number'] == null ? undefined : NovitusSystemNumberDtoFromJSON(json['system_number']),
        'qr_code': json['qr_code'] == null ? undefined : NovitusQrcodeDtoFromJSON(json['qr_code']),
    };
}

export function NovitusSystemInfoDtoToJSON(value?: NovitusSystemInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cashier_name': value['cashier_name'],
        'cash_number': value['cash_number'],
        'system_number': NovitusSystemNumberDtoToJSON(value['system_number']),
        'qr_code': NovitusQrcodeDtoToJSON(value['qr_code']),
    };
}

